<template>
  <div>
    <checkbox-goods-select-form ref="goodsSelect" @goodsSelect="loadSkus" />
    <a-modal :title="$t('选择赠品 SKU')" width="760px" :visible="open" @ok="confirm" @cancel="open = false">
      <a-alert v-if="!skuRows.length" :message="$t('所选商品暂无可用 SKU')" type="warning" show-icon />
      <a-table
        row-key="id"
        :columns="columns"
        :data-source="skuRows"
        :pagination="false"
        :loading="loading"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
      />
    </a-modal>
  </div>
</template>

<script>
import CheckboxGoodsSelectForm from '@/views/goods/goods/modules/CheckboxSelectForm'
import { getGoodsSkuList } from '@/api/goods/goods'

export default {
  name: 'GiftSkuSelectForm',
  components: { CheckboxGoodsSelectForm },
  data () {
    return {
      open: false,
      loading: false,
      skuRows: [],
      selectedRowKeys: [],
      selectedRows: [],
      existing: [],
      columns: [
        { title: this.$t('商品名称'), dataIndex: 'goodsName' },
        { title: 'SKU ID', dataIndex: 'id' },
        { title: this.$t('SKU 规格'), dataIndex: 'skuName' },
        { title: this.$t('SKU 编码'), dataIndex: 'skuCode' },
        { title: this.$t('可用库存'), dataIndex: 'stock' }
      ]
    }
  },
  methods: {
    show (existing) {
      this.existing = existing || []
      this.$refs.goodsSelect.openGoods(undefined, [], undefined, undefined, true)
    },
    async loadSkus (goods) {
      this.loading = true
      this.open = true
      try {
        const responses = await Promise.all(goods.map(item => getGoodsSkuList({ id: item.id })))
        this.skuRows = responses.reduce((rows, response, index) => {
          const goodsName = goods[index].goodsName
          return rows.concat((response.data || []).map(sku => Object.assign({}, sku, {
            goodsId: goods[index].id,
            goodsName: sku.goodsName || goodsName
          })))
        }, [])
        const ids = this.existing.map(item => item.skuId)
        this.selectedRows = this.skuRows.filter(item => ids.includes(item.id))
        this.selectedRowKeys = this.selectedRows.map(item => item.id)
      } finally {
        this.loading = false
      }
    },
    onSelectChange (keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    confirm () {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('请至少选择一个赠品 SKU'))
        return
      }
      this.$emit('select', this.selectedRows)
      this.open = false
    }
  }
}
</script>
